function view_item_list(products, list_name, list_id) {
  let items = [];
  products.forEach(item => items.push({
      item_id: item.variants[0].sku,
      item_name: item.title,
      affiliation: 'Google Store',
      item_brand: item.vendor,
      item_variant: item.variants[0].name,
      price: item.price,
      currency: 'COP',
    }));
  // console.log(products);
  gtag('event', 'view_item_list', {
    items: items,
    item_list_name: list_name,
    item_list_id: list_id
  });
}

function add_to_cart(product) {

  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'COP',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  });
  
  console.log(formatter.format((product.price)?.toString().slice(0, -2)));
  
  gtag('event', 'add_to_cart', {
      currency: 'COP',
      items: [{
        item_id: product.sku,
        item_name:  product.title,
        affiliation: 'Google Store',
        item_brand: product.vendor,
        item_variant: product.variant_title,
        price: formatter.format((product.price)?.toString().slice(0, -2)),
        currency: 'COP',
        quantity: product.quantity
      }],
      value: formatter.format((product.line_price)?.toString().slice(0, -2))
    });
}

function remove_from_cart(product, qty) {
  gtag('event', 'remove_from_cart', {
      currency: 'COP',
      items: [{
        item_id: product.variants[0].sku,
        item_name: product.title,
        affiliation: 'Google Store',
        item_brand: product.vendor,
        item_variant: product.variants[0].name,
        price: product.price,
        currency: 'COP',
        quantity: qty
      }],
      value: product.price
    });
}

function begin_checkout(products, total) {
  let items = [];
  // let all_product = atob(products);
  // all_product = JSON.parse(all_product);
  console.log(products);
  console.log(total);
  
  products.forEach(item => items.push({
    item_id: item?.variants[0].sku,
    item_name: item?.title,
    affiliation: 'Google Store',
    item_brand: item?.vendor,
    item_variant: item?.variants[0].name,
    price: item?.price,
    currency: 'COP',
    qty: item?.qty
  }));

  console.log(items);
  
  gtag('event', 'begin_checkout', {
    currency: 'COP',
    items: items,
    value: total
  });
}

function add_payment_info(products, total, payment) {
  let items = [];
  console.log(products);
  products.forEach(item => items.push({
    item_id: item.variants[0].sku,
    item_name: item.title,
    affiliation: 'Google Store',
    item_brand: item.vendor,
    item_variant: item.variants[0].name,
    price: item.price,
    currency: 'COP',
    qty: item.qty
  }));
  
  gtag('event', 'add_payment_info', {
    currency: 'COP',
    items: items,
    value: total,
    payment_type: payment,
  });
}

function add_shipping_info(products, total) {

  let items = [];
  console.log(products);
  products.forEach(item => items.push({
    item_id: item.variants[0].sku,
    item_name: item.title,
    affiliation: 'Google Store',
    item_brand: item.vendor,
    item_variant: item.variants[0].name,
    price: item.price,
    currency: 'COP',
    qty: item.qty
  }));
  
  gtag('event', 'add_shipping_info', {
    currency: 'COP',
    items: items,
    value: total,
    shipping_tier: 'Ground'
  });
}

function purchase(products, total, checkout_id, shipping_value, tax) {

  let items = [];
  console.log(products);
  products.forEach(item => items.push({
    item_id: item.variants[0].sku,
    item_name: item.title,
    affiliation: 'Google Store',
    item_brand: item.vendor,
    item_variant: item.variants[0].name,
    price: item.price,
    currency: 'COP',
    qty: item.qty
  }));
  
  gtag('event', 'purchase', {
    currency: 'COP',
    items: items,
    transaction_id: checkout_id,
    shipping: shipping_value,
    value: total,
    tax: tax
  });
}

function view_item(item) {
  let product = atob(item);
  product = JSON.parse(product);
  gtag('event', 'view_item', {
    currency: 'COP',
    items: [{
      item_id: product.variants[0].sku,
      item_name: product.title,
      affiliation: 'Google Store',
      item_brand: product.vendor,
      item_variant: product.variants[0].name,
      price: product.price,
      currency: 'COP',
    }],
    value: product.price
  });
}

function select_item(item) {
  let product = atob(item);
  product = JSON.parse(product);
  // alert(product);
  gtag('event', 'select_item', {
    items: [{
      item_id: product.variants[0].sku,
      item_name: product.title,
      item_list_name: 'Prueba Products',
      item_list_id: 'prueba_products',
      affiliation: 'Google Store',
      item_brand: product.vendor,
      item_variant: product.variants[0].name,
      price: product.price,
      currency: 'COP',
    }],
    item_list_name: 'Prueba products',
    item_list_id: 'prueba_products'
  });
}